import type { FC, ReactElement } from "react"

import { THEME } from "@/3514/theme"
import { ERoundDirection, buildCssClassName, getTransitionTwClasses } from "@/3514/utils"

type TProps = {
    width?: number
    height?: number
    fillColor?: string
    className?: string
    direction?: ERoundDirection
}

const classes = ({ direction }: { direction: ERoundDirection }): string =>
    buildCssClassName(
        {
            "rotate-[90deg]": direction === ERoundDirection.Top,
            "rotate-[180deg]": direction === ERoundDirection.Right,
            "rotate-[270deg]": direction === ERoundDirection.Bottom
        },
        getTransitionTwClasses("all", 150)
    )

const Icon: FC<TProps> = ({
    width = 10,
    height = 12,
    fillColor = THEME.COLORS.accent,
    className = String(),
    direction = ERoundDirection.Left
}: TProps): ReactElement => (
    <svg
        width={width}
        height={height}
        className={buildCssClassName(classes({ direction }), { [className]: className })}
        viewBox="0 0 7 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M6.10156 0.800781L1.90156 5.00078L6.10156 9.20078"
            className={getTransitionTwClasses("colors")}
            stroke={fillColor}
            strokeWidth="1.5"
        />
    </svg>
)

Icon.displayName = "ArrowIcon"

export { Icon as ArrowIcon }
